import { Controller } from '@stimulus/core'

export default class extends Controller {
  static targets = [ 'radioButton' ]

  connect() {
    this.form = this.element
    this.radioButtonTargets.forEach(radioButton => {
      radioButton.addEventListener('change', e => {
        this.form.requestSubmit()
      })
    })
  }
}
